<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import tableheader from "../tableheader/index";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Onay Bekleyen Talepler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,  treeselect,tableheader
  },
  data() {
    return {
      title: "Onay Bekleyen Talepler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Onay Bekleyen Talepler",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      Filter: {
        OrderBy: "Desc=Takipno",
        Atananbirimid: null,
        Durumid: null,
        Oncelikid: null,
        Atananpersonelid: null,
        Olusturmatarihi: null,
        Guncellemetarih: null,
        Takipno: null,
        Uygulamaid: null,
        Ucretli:null,
        Baslik:null,
        Aciklama:null,
        Olusturmatarihibas: null,
        Olusturmatarihibit: null,
        Guncellemetarihibas: null,
        Guncellemetarihibit: null,
        Tahminibitisbas: null,
        Tahminibitisbit: null,
        Amirred: null
      }
    };
  },
 
  methods: {
    Get() {
      var Filter = "&Amirid=" + this.TokenPersonelId + "&Amironaysiz=true&" + this.Filter.OrderBy
     
      if (this.Filter.Baslik != null && this.Filter.Baslik != ""  && 
      typeof this.Filter.Baslik === "string" && this.Filter.Baslik.length > 2) {
        Filter += "&Baslik=" + this.Filter.Baslik
      }
      if (this.Filter.Aciklama != null && this.Filter.Aciklama != "" && 
      typeof this.Filter.Aciklama === "string" && this.Filter.Aciklama.length > 2) {
        Filter += "&Aciklama=" + this.Filter.Aciklama
      }
      if (this.Filter.Ucretli != null && this.Filter.Ucretli != "") {
        Filter += "&Ucretli=" + this.Filter.Ucretli
      }
      if (this.Filter.Takipno != null && this.Filter.Takipno != "") {
        Filter += "&Takipno=" + this.Filter.Takipno
      }
      if (this.Filter.Durumid != null && this.Filter.Durumid != "") {
        Filter += "&Durumid=" + this.Filter.Durumid
      }
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        Filter += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Olusturmatarihibas != null && this.Filter.Olusturmatarihibas != "") {
        Filter += "&Olusturmatarihibas=" + this.Filter.Olusturmatarihibas
      }
      if (this.Filter.Olusturmatarihibit != null && this.Filter.Olusturmatarihibit != "") {
        Filter += "&Olusturmatarihibit=" + this.Filter.Olusturmatarihibit
      }
      if (this.Filter.Guncellemetarihibas != null && this.Filter.Guncellemetarihibas != "") {
        Filter += "&Guncellemetarihibas=" + this.Filter.Guncellemetarihibas
      }
      if (this.Filter.Guncellemetarihibit != null && this.Filter.Guncellemetarihibit != "") {
        Filter += "&Guncellemetarihibit=" + this.Filter.Guncellemetarihibit
      } 
      
      if (this.Filter.Amirred != null && this.Filter.Amirred != "") {
        Filter += "&Amirred=" + this.Filter.Amirred
      }
      this.ActionsFilterGet({
        Service: "tlptalep",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    
    OnayRed(Data,Durum){
      Data.Amironay = Durum 
       this.Update("tlptalep", Data)
    },

    goToDetailPage(Id) {
        const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
        window.open(routeData.href, '_blank'); 
    },

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3"  >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">

                        <b-form-group class="col-lg-3" label="Takip Numarası"  >
                            <b-form-input  v-model="Filter.Takipno"   type="number"  ></b-form-input> 
                            </b-form-group>

                          <b-form-group class="col-lg-3" label="Başlık"  >
                            <b-form-input  v-model="Filter.Baslik"   type="text"  ></b-form-input> 
                            </b-form-group>
                          <b-form-group class="col-lg-3" label="Açıklama"  >
                            <b-form-input  v-model="Filter.Aciklama"   type="text"  ></b-form-input> 
                            </b-form-group>


  

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>

                 
  

                            <b-form-group class="col-lg-3" label="Oluşturma Tarihi Başlangıç">
                          <b-form-input v-model="Filter.Olusturmatarihibas" type="date"></b-form-input>
                        </b-form-group>
                        <b-form-group class="col-lg-3" label="Oluşturma Tarihi Bitiş">
                          <b-form-input v-model="Filter.Olusturmatarihibit" type="date"></b-form-input>
                        </b-form-group>    <b-form-group  class="col-lg-1"  
                              label="Reddedilenler dahil" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Amirred" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>
                         
                        <div class="col-lg-3"> 
                          <button class="btn btn-success mt-4" data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Page.PageNumber = 1,Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div> 
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                    <tableheader @OrderBy="Filter.OrderBy = $event , Get()" :Data='
                      [
                        { "Takipno": "Takip No" },
                        { "Baslik": "Başlık" },
                        { "Olusturan": "Talep Sahibi" },  
                        { "Taleptip": "Talep Tipi" },  
                        { "Oncelik": "Öncelik" },   
                        { "Created": "Açılma Tarihi" },
                        { "": "İşlem" },
                      ]' />
                   </tr>    
                    
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td>{{ Data.Olusturan }}</td>  
                      <td>{{ Data.Taleptip }}</td>  
                      <td :class="OncelikRenklendirme(Data.Oncelik)">{{ Data.Oncelik }}</td>   
                      <td>{{ Data.Created != null ? formatDateTable(Data.Created) : '' }}</td> 
                      <td>
                        <div class="
                            action-is
                            w-100 
                            d-flex
                            justify-content-center
                            align-items-center
                          "> 
                          <b-button-group>
                            <b-button v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Id)"><i
                                class="far fa-eye"></i></b-button>
 
                            <b-button v-if='!Data.Amironay'
                            v-b-tooltip.hover title="Onay" variant="success" v-b-modal.tlptalep
                              @click="OnayRed(Data,true)"><i class="fas fa-check"></i></b-button>

                              
                            <b-button v-if="Data.Amironay != false"
                            v-b-tooltip.hover title="Red" variant="danger" v-b-modal.tlptalep
                              @click="OnayRed(Data,false)"><i class="fas fa-times"></i></b-button>
 
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>  
                <br /> <b>Toplam Kayıt Sayısı: {{ Page.PageDataSize }}</b>
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"    
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))"> 
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </Layout>
  </Loader>
</template>
